import { Cookies } from '../libs';

const getDyCookieDomain = () => {
	const hostname = window.location.hostname.toLowerCase().replace( /\.$/, '' );
	return hostname.startsWith( 'www.' ) ? hostname.slice( 4 ) : undefined;
};

const removeDyServerCookie = () => {
	Cookies.remove( '_dyid_server', { path: '/', secure: true } );

	const domain = getDyCookieDomain();
	if ( domain ) {
		Cookies.remove( '_dyid_server', { path: '/', secure: true, domain } );
	}
};

let dyCookieConsent = false;

/**
 * Set Consent Status on Change.
 */
window.addEventListener( 'UC_GENERAL', function( ev ) {
	if ( ev.detail && 'consent_status' === ev.detail.event ) {
		const consentStatus = ev.detail[ 'Dynamic Yield' ];
		window.DY ??= {};
		window.DY.userActiveConsent = {
			accepted: consentStatus,
		};

		if ( 'function' === typeof window.DYO?.ActiveConsent?.updateConsentAcceptedStatus ) {
			window.DYO.ActiveConsent.updateConsentAcceptedStatus( consentStatus );
		}
		window.localStorage.setItem( 'DYUserActiveConsent', consentStatus );
	}
} );

/**
 * Set the DYID_Server Cookie, depending on consent status.
 */
window.addEventListener( 'UC_GENERAL', function( ev ) {
	// Set DYID_Server Cookie, if we have consent.
	if ( ev.detail && 'consent_status' === ev.detail.event && 'Dynamic Yield' in ev.detail ) {
		dyCookieConsent = Boolean( ev.detail[ 'Dynamic Yield' ] );
		// Consent given - set dy server cookie from server
		if ( ev.detail[ 'Dynamic Yield' ] ) {
			// the _dyid cookie does not exist - we don't need to set a server cookie without an existing client.
			if ( ! Cookies.get( '_dyid' ) ) {
				return;
			}

			// The dyid_server cookie was already set in the last 7 days, so we don't need to call the server again.
			if ( Cookies.get( '_dyid_server' ) && Cookies.get( '_dyid_set' ) ) {
				return;
			}

			// Settings for Fetch.
			const settings = {
				credentials: 'include',
				mode: 'no-cors',
			};

			// Call Server - This sets the _dyid_server Cookie in Response Header.
			fetch( '/cms/dispatch/cookie/dynamic-yield/', settings ).then( ( response ) => {
				if ( ! dyCookieConsent ) {
					removeDyServerCookie();
					return;
				}
				if ( ! response.ok || ! Cookies.get( '_dyid_server' ) ) {
					return;
				}
				// Set a cookie for seven days, so we refresh the cookie when accessed again after that period.
				Cookies.set( '_dyid_set', 1, { expires: 7, path: '/', secure: true } );
			} ).catch( () => {
				// Leave the refresh marker unset so the next consent event can retry.
			} );
		} else {
			// Consent revoked - remove the server cookie and the host refresh marker.
			removeDyServerCookie();
			Cookies.remove( '_dyid_set', { path: '/', secure: true } );
		}
	}
} );
